// extracted by mini-css-extract-plugin
module.exports = {"root":"root-XpTA_","success":"success-2bFc2","loading":"loading-2ZEN9","colorPrimary":"colorPrimary-2cyi4"};